export default "__VITE_ASSET__5415f268__"